app.service('subscriptionEncouragement', function (modal, loading, orderConfig) {
	let $modal;

	function setEvents() {
		$('.js-long-introduction', $modal).click(function () {
			$(this).closest('.introduction').toggleClass('show-introduction');
			// UA.interaction('PG', 'Abonament', 'Szczegoly');
		});
		$('.remodal-close', $modal).click(function () {
			// UA.interaction('PG', 'Abonament', 'Zrob to pozniej');
		});
		$('.js-footer-message', $modal).click(function () {
			$(this).closest('.footer-message').toggleClass('show-message');
			// UA.interaction('PG', 'Abonament', 'Co warto wiedziec');
		});

		$('.js-subscribe-card', $modal).click(function subscribeCard() {
			set();
		});
	}
	function set() {
		let config = orderConfig.getData();
		loading.start();
		$.ajax({
			method: 'POST',
			url: '/subscription-transaction-payment.ltr',
			data: {
				orderNumber: config.orderNumber
			}
		}).then(response => {
			if (response.status === 'FAIL') {
				loading.stop();
				modal.alert(response.messages.join(''));
			} else {
				loading.redirect({
					href: response.transactionPaymentUrl,
					soft: false
				});
			}
		}).fail(() => {
			loading.stop();
			modal.alert('Wystąpiły problemy techniczne. Spróbuj powtórzyć operację w koncie klienta lub skontaktuj się z działem pomocy.');
		});
	}
	function open() {
		let config = orderConfig.getData();
		loading.start();
		$.ajax({
			data: {
				orderNumber: config.orderNumber
			},
			url: '/order-path-subscription-encouragement.ltr',
			success: function (html) {
				loading.stop();
				$modal = modal.generate({
					id: 'subscription-encouragement',
					close: true,
					content: html,
				}).$modal;
				setEvents();
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpiły problemy techniczne. Spróbuj dodać kartę lub BLIKA w koncie klienta lub skontaktuj się z działem pomocy.');
			}
		});
	}
	return {
		open
	};
});
